import React from 'react';
import { observer } from 'mobx-react';
import { LinearProgress, ListItem } from '@material-ui/core';
import { TextAsset } from '../../../../../../types';
import { useTextAssetListItem } from './hooks/useTextAssetListItem';
import useStyles from './TextAssetItem.styles';
import { TextAssetViewMode } from './components/TextAssetViewMode';
import { TextAssetEditMode } from './components/TextAssetEditMode';

interface Props {
  textAsset: TextAsset;
}

export const TextAssetItem: React.FC<Props> = observer(({ textAsset }: Props) => {
  const {
    activeTabKey,
    editedTextAsset,
    isSelected,
    isRemoving,
    isCalculating,
    isShowingPostMaloneScore,
    isSaving,
    isSuggestion,
    handleSelect,
    handleRemove,
    handleCopyToClipboard,
    handleOpenEditMode,
    handleExitEditMode,
    handleInputChange,
    handleSave,
    maxLengthLabelAttrs
  } = useTextAssetListItem(textAsset);
  const classes = useStyles(activeTabKey)();

  return (
    <ListItem dense className={classes.ItemRoot} selected={isSelected}>
      {(isRemoving || isSaving) && <LinearProgress className={classes.LinearProgress} />}
      {editedTextAsset ? (
        <TextAssetEditMode
          textAsset={textAsset}
          editedTextAsset={editedTextAsset}
          activeTabKey={activeTabKey}
          isShowingPostMaloneScore={isShowingPostMaloneScore}
          isCalculating={isCalculating}
          isSaving={isSaving}
          handleInputChange={handleInputChange}
          handleSave={handleSave}
          handleExitEditMode={handleExitEditMode}
          maxLengthLabelAttrs={maxLengthLabelAttrs}
        />
      ) : (
        <TextAssetViewMode
          textAsset={textAsset}
          activeTabKey={activeTabKey}
          isSelected={isSelected}
          isRemoving={isRemoving}
          isSuggestion={isSuggestion}
          handleOpenEditMode={handleOpenEditMode}
          handleCopyToClipboard={handleCopyToClipboard}
          handleSelect={handleSelect}
          handleRemove={handleRemove}
        />
      )}
    </ListItem>
  );
});
